import { kyWithAuth } from '../libs/ky';

export const paymentService = {
  /**
   * Créer un Payment Intent Stripe
   */
  async createPaymentIntent(orderId, amount, currency = 'eur') {
    try {
      console.log('🐛 URL API:', process.env.VUE_APP_API_HOST);
      console.log('🐛 Calling:', `${process.env.VUE_APP_API_HOST}/payments/intent`);
      console.log('🐛 Data:', { orderId, amount, currency });

      const response = await kyWithAuth
        .post('payments/intent', {
          json: {
            orderId,
            amount,
            currency
          }
        })
        .json();
      return response;
    } catch (error) {
      console.error('Erreur création Payment Intent:', error);
      throw error;
    }
  },

  /**
   * Confirmer un paiement
   */
  async confirmPayment(paymentIntentId, orderId) {
    try {
      const response = await kyWithAuth
        .post('payments/confirm', {
          json: {
            paymentIntentId,
            orderId
          }
        })
        .json();
      return response;
    } catch (error) {
      console.error('Erreur confirmation paiement:', error);
      throw error;
    }
  },

  /**
   * Récupérer le statut d'un paiement
   */
  async getPaymentStatus(orderId) {
    try {
      const response = await kyWithAuth.get(`payments/status/${orderId}`).json();
      return response;
    } catch (error) {
      console.error('Erreur récupération statut:', error);
      throw error;
    }
  }
};
